import { WorkflowStatus } from '../../types/WorkflowState';
import { completedStatuses } from './types';
import { Case } from '../../types/Case';
import { Enrichments } from '../../types/Enrichments';

// Default columns configuration
export const defaultColumns = [
  { display: true, id: 'sector', label: 'Sector', order: 0 },
  { display: true, id: 'fitScore', label: 'Fit Score', order: 1 },
  { display: true, id: 'ups', label: 'USP', order: 2 },
  { display: true, id: 'tech', label: 'Tech', order: 3 },
  { display: true, id: 'patents', label: 'Patents', order: 4 },
  { display: true, id: 'team', label: 'Team', order: 5 },
  { display: true, id: 'dataCoverage', label: 'Data Coverage', order: 6 },
  { display: true, id: 'risks', label: 'Risks', order: 7 },
];
export const getGetWorkflowStatus = (status: WorkflowStatus | null): boolean => {
  return status ? completedStatuses.includes(status) : false;
};
export const isOlderThan1Hour = (dateString: string | null): boolean => {
  if (!dateString) return false;
  return new Date().getTime() - new Date(dateString).getTime() > 60 * 60 * 1000;
};

// project selected functions
export const isProjectDisabled = (
  status: WorkflowStatus | null,
  dateString: string | null
): boolean => {
  const olderThan1Hour = isOlderThan1Hour(dateString); // true if updated more than 1 hour ago
  const workflowCompleted = getGetWorkflowStatus(status);

  return !olderThan1Hour && !workflowCompleted;
};

// FitScore
export const triggerFitScoreSurvey = (org_id: string, user_id: string, environment: string) => {
  window.open(getFitScoreSurveyLink(org_id, user_id, environment), '_blank')?.focus();
};

export const getFitScoreSurveyLink = (org_id: string, user_id: string, environment: string) => {
  return `https://contact376803.typeform.com/fit-score#org_id=${org_id}&user_id=${user_id}&environment=${environment}`;
};

//enrichments functions
export const getStageIcon = (investment_stage: string) => {
  const stage = investment_stage?.toLowerCase();
  switch (stage) {
    case 'pre-seed':
      return 'PS';
    case 'seed':
      return 'S';
    case 'series a':
      return 'A';
    case 'series b':
      return 'B';
    case 'series c':
      return 'C';
    default:
      return '';
  }
};
export const getFoundersString = (enrichments: Enrichments) => {
  return enrichments?.founders
    ? enrichments.founders
        .filter(founder => founder.name && founder.name !== 'null' && founder.name.trim() !== '')
        .map(founder => {
          const parts = [founder.name, founder.role, founder.degree].filter(
            part => part && part !== 'null' && part.trim() !== ''
          );
          return parts.join(', ');
        })
        .join('\n')
    : '';
};

//widget filter fuctions
export const completionFilter = (data: Case[]) => {
  return data.filter(
    item =>
      item?.workflow_state?.data_availability?.combined &&
      typeof item.workflow_state.data_availability.combined === 'number' &&
      item.workflow_state.data_availability.combined >= 0.75
  );
};

export const newFilter = (data: Case[]) => {
  const date = new Date();
  date.setDate(date.getDate() - 7);
  return data.filter(
    item => item?.details.created_date && new Date(item.details.created_date) >= date
  );
};
export const sharedFilter = (data: Case[]) => {
  return data.filter(item => item.role !== 'Owner');
};

export const fitScoreFilter = (data: Case[]) => {
  return data.filter(
    item => !!item?.enrichments?.fit_score && item?.enrichments?.fit_score.score >= 5
  );
};
